import { useContext, useEffect } from 'react';
import { GlobalConfigContext } from "../contexts/globalConfigContext"
import io from "socket.io-client"


const SocketManagerConfig = () => {
    const { configSocketRef, socketToken } = useContext(GlobalConfigContext);

    useEffect(() => {
        configSocketRef.current = io.connect(process.env.REACT_APP_CMS_URL, {
            secure: true,
            reconnect: true,
            rejectUnauthorized: true,
            query: { token: socketToken }
        })

        configSocketRef.current.on('connect', function () {
            configSocketRef.current.emit("CONFIG_ADD_CLIENT_TO_SOCKETS");
        });

        return () => {
            configSocketRef.current.disconnect();
        }
        
    }, [])

    return (
        <> </>
    );
}

export default SocketManagerConfig;